import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'
import { AuthResponse } from "../models/response/AuthResponse"
import { API_URL } from '../appConfig'

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL
})

$api.interceptors.request.use((config) => {
    const access = localStorage.getItem('access')
    if (access) {
        config.headers!.Authorization = `Bearer ${access}`
    } else {
        delete config.headers!.Authorization
    }
    return config
})

$api.interceptors.response.use(
    (config) => {
        return config;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && error.response?.data.code === 'token_not_valid' && error.config && error.config['url'].indexOf('/auth/jwt/verify/') === -1) {
            originalRequest._isRetry = true;
            const refresh = localStorage.getItem('refresh')
            try {    
                const response = await axios.post<AuthResponse>(`${API_URL}auth/jwt/refresh`, {refresh, withCredentials: true})
                localStorage.setItem('access', response.data.access)
                // localStorage.setItem('refresh', response.data.refresh)
                return $api.request(originalRequest)
            } catch (e) {
                console.log('Не авторизован')
                localStorage.removeItem('access')
                localStorage.removeItem('refresh')
            }
        }
        throw error
    })

export default $api